import { render } from "./AnnouncementEdit.vue?vue&type=template&id=a099a0e4&scoped=true"
import script from "./AnnouncementEdit.vue?vue&type=script&lang=js"
export * from "./AnnouncementEdit.vue?vue&type=script&lang=js"

import "./AnnouncementEdit.vue?vue&type=style&index=0&id=a099a0e4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a099a0e4"

export default script